import React from "react";

const Main_Dashboard = React.lazy(() =>
  import("./components/main_dashboard/Main_Dashboard"),
);

const Profile = React.lazy(() => import("./components/header/profile/Profile"));

const Notification = React.lazy(() =>
  import("./components/header/notification/Notification"),
);

const Out_For_Delivery = React.lazy(() =>
  import("./components/orders/out_for_delivery/Out_For_Delivery"),
);

const Receive_Product = React.lazy(() =>
  import("./components/orders/receive_product/Receive_Product"),
);

const Delayed = React.lazy(() => import("./components/orders/delayed/Delayed"));

const Pending = React.lazy(() => import("./components/orders/pending/Pending"));

const Replacement = React.lazy(() =>
  import("./components/orders/replacement/Replacement"),
);

const Repair = React.lazy(() => import("./components/orders/repair/Repair"));

const Delivered_Today = React.lazy(() =>
  import("./components/orders/delivered-today/Delivered_Today"),
);

const Payments = React.lazy(() => import("./components/payments/Payments"));

const Sales_Team = React.lazy(() =>
  import("./components/sales-team/Sales_Team"),
);

const New_Customer = React.lazy(() =>
  import("./components/new-customer/New_Customer"),
);

const Electricity_Bills = React.lazy(() =>
  import("./components/electricity-bills/Electricity_Bills"),
);

const Store_Kharch = React.lazy(() =>
  import("./components/store-kharch/Store_Kharch"),
);

const Order_Billing = React.lazy(() =>
  import("./components/order-billing/Order_Billing"),
);

const Setup = React.lazy(() => import("./components/setup/Setup"));

const Raise_Your_Request = React.lazy(() =>
  import("./components/raise-your-request/Raise_Your_Request"),
);

const Inventory_Request = React.lazy(() =>
  import("./components/inventory-request/Inventory_Request"),
);

const Store_All_Inventory = React.lazy(() =>
  import("./components/store-all-inventory/Store_All_Inventory"),
);

const Lensmartin_Store = React.lazy(() =>
  import("./components/lensmartin-store/Lensmartin_Store"),
);

const routes = [
  { path: "/dashboard", name: "Home", element: Main_Dashboard },
  { path: "/profile", name: "Profile", element: Profile },
  { path: "/notification", name: "Notification", element: Notification },
  { path: "/orders/out-for-delivery", name: "Home", element: Out_For_Delivery },
  { path: "/orders/receive-product", name: "Home", element: Receive_Product },
  { path: "/orders/delayed", name: "Home", element: Delayed },
  { path: "/orders/pending", name: "Home", element: Pending },
  { path: "/orders/replacement", name: "Home", element: Replacement },
  { path: "/orders/repair", name: "Home", element: Repair },
  { path: "/orders/delivered-today", name: "Home", element: Delivered_Today },
  { path: "/payments", name: "Home", element: Payments },
  { path: "/sales-team", name: "Home", element: Sales_Team },
  { path: "/new-customer", name: "Home", element: New_Customer },
  { path: "/electricity-bills", name: "Home", element: Electricity_Bills },
  { path: "/store-kharch", name: "Home", element: Store_Kharch },
  { path: "/order-billing", name: "Home", element: Order_Billing },
  { path: "/setup", name: "Home", element: Setup },
  { path: "/raise-your-request", name: "Home", element: Raise_Your_Request },
  { path: "/inventory-request", name: "Home", element: Inventory_Request },
  { path: "/store-all-inventory", name: "Home", element: Store_All_Inventory },
  { path: "/lensmartin-store", name: "Home", element: Lensmartin_Store },
];

export default routes;
